export default __webpack_public_path__ + "static/playground-aade423e2a0b48f30a1ee13c88da10e1.png";